/* PALPāTE theme scripts */
function toggleMenu(){ var n=document.getElementById('mobileNav'); if(n) n.classList.toggle('open'); }
function toggleAcc(btn){ btn.closest('.acc-item').classList.toggle('open'); }
function setImg(){ /* replaced by the gallery below */ }

/* Header shadow on scroll */
(function(){
  var h=document.getElementById('mainHeader'); if(!h) return;
  window.addEventListener('scroll',function(){ h.classList.toggle('scrolled',window.scrollY>30); },{passive:true});
})();

/* Fade-up */
(function(){
  var els=document.querySelectorAll('.fade-up'); if(!els.length) return;
  if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('visible');}); return; }
  var obs=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting) e.target.classList.add('visible'); }); },{threshold:0.1});
  els.forEach(function(el){ obs.observe(el); });
})();

/* Hero banner carousel */
(function(){
  var track=document.getElementById('mHeroTrack'); if(!track) return;
  var dots=[].slice.call(document.querySelectorAll('#mHeroDots button'));
  var n=track.children.length, idx=0, timer, ms=parseInt(track.getAttribute('data-interval'),10)||5000;
  if(n<2) return;
  function go(i){ idx=(i+n)%n; track.scrollTo({left:idx*track.clientWidth}); }
  function auto(){ clearInterval(timer); timer=setInterval(function(){ if(track.offsetParent) go(idx+1); },ms); }
  track.addEventListener('scroll',function(){ var i=Math.round(track.scrollLeft/track.clientWidth); idx=i; dots.forEach(function(d,k){ d.classList.toggle('active',k===i); }); },{passive:true});
  track.addEventListener('touchstart',function(){ clearInterval(timer); },{passive:true});
  track.addEventListener('touchend',auto,{passive:true});
  dots.forEach(function(d,k){ d.addEventListener('click',function(){ go(k); auto(); }); });
  auto();
})();

/* Home product carousel */
(function(){
  var t=document.getElementById('hpTrack'), p=document.getElementById('hpPrev'), n=document.getElementById('hpNext');
  if(!t||!p||!n) return;
  function stepW(){ var c=t.querySelector('.prod-card'); if(!c) return t.clientWidth; var g=parseFloat(getComputedStyle(t).columnGap)||0; return c.getBoundingClientRect().width+g; }
  function upd(){ var max=t.scrollWidth-t.clientWidth-2; p.disabled=t.scrollLeft<=2; n.disabled=t.scrollLeft>=max; }
  p.addEventListener('click',function(){ t.scrollBy({left:-stepW(),behavior:'smooth'}); });
  n.addEventListener('click',function(){ t.scrollBy({left:stepW(),behavior:'smooth'}); });
  t.addEventListener('scroll',function(){ requestAnimationFrame(upd); },{passive:true});
  window.addEventListener('resize',upd); upd();
})();

/* Testimonials carousel */
(function(){
  var track=document.getElementById('testiTrack'), dotsWrap=document.getElementById('testiDots');
  if(!track||!dotsWrap) return;
  var totalCards=track.querySelectorAll('.testi-card').length;
  function perPage(){ return window.innerWidth<=580?1:3; }
  var tCurrent=0, tPages=Math.ceil(totalCards/perPage());
  function buildDots(){
    tPages=Math.ceil(totalCards/perPage()); dotsWrap.innerHTML='';
    for(var i=0;i<tPages;i++){ (function(i){ var b=document.createElement('button'); b.type='button'; b.className='dot-btn'+(i===0?' active':''); b.setAttribute('aria-label','Reviews page '+(i+1)); b.onclick=function(){ goTesti(i); }; dotsWrap.appendChild(b); })(i); }
  }
  function goTesti(n){
    tCurrent=Math.max(0,Math.min(n,tPages-1));
    var pp=perPage(), cardW=track.parentElement.offsetWidth, gap=22.4;
    var slideW=(cardW-gap*(pp-1))/pp, offset=tCurrent*(slideW+gap)*pp;
    track.style.transform='translateX(-'+offset+'px)';
    dotsWrap.querySelectorAll('.dot-btn').forEach(function(d,i){ d.classList.toggle('active',i===tCurrent); });
  }
  window.moveTesti=function(dir){ tPages=Math.ceil(totalCards/perPage()); goTesti((tCurrent+dir+tPages)%tPages); };
  buildDots();
  window.addEventListener('resize',function(){ buildDots(); goTesti(0); });
})();

/* Quantity steppers (product + cart) */
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-qty-step]'); if(!b) return;
  var wrap=b.closest('[data-qty]'), input=wrap&&wrap.querySelector('input'); if(!input) return;
  var min=parseInt(input.min||'0',10), v=(parseInt(input.value,10)||0)+parseInt(b.getAttribute('data-qty-step'),10);
  input.value=Math.max(min,v);
  input.dispatchEvent(new Event('change',{bubbles:true}));
});
document.addEventListener('change',function(e){
  if(e.target.matches('[data-autosubmit]')){ var f=e.target.form; clearTimeout(f._t); f._t=setTimeout(function(){ f.submit(); },500); }
});

/* Variant picker: update price + URL */
(function(){
  var sel=document.getElementById('VariantSelect'), price=document.querySelector('[data-product-price]');
  if(!sel||!price) return;
  sel.addEventListener('change',function(){
    var o=sel.options[sel.selectedIndex], c=o.getAttribute('data-compare');
    price.innerHTML=o.getAttribute('data-price')+(c?' <s class="price-mrp">'+c+'</s>':'');
    var u=new URL(window.location.href); u.searchParams.set('variant',sel.value); history.replaceState({},'',u.toString());
  });
})();

/* Product image gallery: swipe, arrows, full-screen viewer */
(function(){
  var thumbs=[].slice.call(document.querySelectorAll('.img-thumb'));
  var main=document.getElementById('mainImg');
  var box=document.querySelector('.img-main');
  if(!main||!box||!thumbs.length) return;

  var imgs=thumbs.map(function(t){
    var m=(t.getAttribute('onclick')||'').match(/setImg\(\s*this\s*,\s*'([^']+)'(?:\s*,\s*'([^']+)')?/);
    return m?{src:m[1],fb:m[2]||''}:{src:t.querySelector('img').src,fb:''};
  });
  var n=imgs.length, cur=Math.max(0,thumbs.findIndex(function(t){return t.classList.contains('active');}));
  var L='<svg viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>', R='<svg viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg>';

  function mkImg(i){
    var im=new Image(); im.alt=main.alt||''; im.decoding='async'; im.draggable=false;
    var fb=imgs[i].fb; if(fb) im.onerror=function(){im.onerror=null;im.src=fb;};
    im.src=imgs[i].src; return im;
  }
  function buildTrack(){
    var t=document.createElement('div'); t.className='pg-track';
    for(var i=0;i<n;i++){ var s=document.createElement('div'); s.className='pg-slide'; s.appendChild(mkImg(i)); t.appendChild(s); }
    return t;
  }
  function arrows(parent){
    if(n<2) return [];
    var p=document.createElement('button'); p.className='pg-arrow pg-prev'; p.setAttribute('aria-label','Previous image'); p.innerHTML=L;
    var q=document.createElement('button'); q.className='pg-arrow pg-next'; q.setAttribute('aria-label','Next image'); q.innerHTML=R;
    parent.appendChild(p); parent.appendChild(q); return [p,q];
  }

  /* inline gallery */
  var track=buildTrack(); box.appendChild(track);
  var count=document.createElement('div'); count.className='pg-count'; box.appendChild(count);
  var mainArrows=arrows(box);

  /* full-screen viewer */
  var lb=document.createElement('div'); lb.className='pg-lb'; lb.setAttribute('role','dialog'); lb.setAttribute('aria-modal','true'); lb.setAttribute('aria-label','Product images');
  var lbTrack=buildTrack(); lb.appendChild(lbTrack);
  var closeBtn=document.createElement('button'); closeBtn.className='pg-lb-close'; closeBtn.setAttribute('aria-label','Close'); closeBtn.innerHTML='<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>'; lb.appendChild(closeBtn);
  var lbArrows=arrows(lb);
  var lbCount=document.createElement('div'); lbCount.className='pg-lb-count'; lb.appendChild(lbCount);
  document.body.appendChild(lb);

  function isOpen(){ return lb.classList.contains('open'); }
  function label(){ var t=(cur+1)+' / '+n; count.textContent=t; lbCount.textContent=n>1?t:''; }
  function go(t,i,smooth){ t.scrollTo({left:i*t.clientWidth,behavior:smooth?'smooth':'auto'}); }
  function setCur(i){
    i=Math.max(0,Math.min(n-1,i)); if(i===cur) return; cur=i;
    thumbs.forEach(function(t,k){t.classList.toggle('active',k===cur);}); label();
  }
  function watch(t){
    var raf=0;
    t.addEventListener('scroll',function(){
      if(raf) cancelAnimationFrame(raf);
      raf=requestAnimationFrame(function(){ var w=t.clientWidth; if(w) setCur(Math.round(t.scrollLeft/w)); });
    },{passive:true});
  }
  watch(track); watch(lbTrack);

  function step(d){ var i=cur+d; if(i<0) i=n-1; if(i>=n) i=0; go(isOpen()?lbTrack:track,i,true); }
  /* thumbnails keep working through the page's existing setImg() */
  window.setImg=function(thumb){ var i=thumbs.indexOf(thumb); if(i>-1) go(track,i,true); };

  function open(){ lb.classList.add('open'); document.body.style.overflow='hidden'; go(lbTrack,cur,false); label(); closeBtn.focus({preventScroll:true}); }
  function close(){ go(track,cur,false); lb.classList.remove('open'); document.body.style.overflow=''; }

  if(mainArrows.length){ mainArrows[0].addEventListener('click',function(e){e.stopPropagation();step(-1);}); mainArrows[1].addEventListener('click',function(e){e.stopPropagation();step(1);}); }
  if(lbArrows.length){ lbArrows[0].addEventListener('click',function(e){e.stopPropagation();step(-1);}); lbArrows[1].addEventListener('click',function(e){e.stopPropagation();step(1);}); }
  track.addEventListener('click',open);
  closeBtn.addEventListener('click',close);
  lb.addEventListener('click',function(e){ if(e.target.classList.contains('pg-slide')||e.target===lb) close(); });
  document.addEventListener('keydown',function(e){
    if(!isOpen()) return;
    if(e.key==='Escape') close(); else if(e.key==='ArrowLeft') step(-1); else if(e.key==='ArrowRight') step(1);
  });
  window.addEventListener('resize',function(){ go(track,cur,false); if(isOpen()) go(lbTrack,cur,false); });

  if(cur) go(track,cur,false);
  label();
})();
